import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {IconDetailComponent, IconDetailModel} from "../icon-detail/icon-detail.component";
import {AccountModel} from "../../domain/models/account.model";
import {Icons} from "../../domain/enums/icons-enums";

@Component({
  selector: 'app-property-resume-bar',
  standalone: true,
  imports: [
    IconDetailComponent
  ],
  template: `
    <div class="row">
      <div class=" shrink">
        <app-icon-detail [model]="customerId"></app-icon-detail>
      </div>
      <div class=" shrink">
        <app-icon-detail [model]="owner"></app-icon-detail>
      </div>
      <div class=" shrink">
        <app-icon-detail [model]="propertyId"></app-icon-detail>
      </div>
    </div>
  `
})
export class PropertyResumeBarComponent implements OnChanges {
  @Input() customer: AccountModel | undefined;
  customerId: IconDetailModel | undefined;
  owner: IconDetailModel | undefined;
  propertyId: IconDetailModel | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.customer)
    this.customerId = { icon: Icons.FingerprintIcon, label: 'Customer ID', value: this.customer?.id?.toString() };
    this.owner = { icon: Icons.PersonPinIcon, label: 'Owner', value: this.customer?.entityName };
    this.propertyId = { icon: Icons.HotelIcon, label: 'Property ID', value: this.customer?.rentalProperty?.id?.toString() };
  }
}
